<!-- <div class="side-nav">

</div> -->

<div class="sidebar-logo" >
  <a href="/" >
    <!-- <svg xmlns="http://www.w3.org/2000/svg" width="88" height="44" viewBox="0 0 88 44" *ngIf="!isCollapsed">
      <path id="Path_3" data-name="Path 3" d="M16.8,0A16.8,16.8,0,1,1,0,16.8,16.8,16.8,0,0,1,16.8,0Z" transform="translate(0 7.616)" fill="#fff"/>
      <path id="Path_4" data-name="Path 4" d="M15.319,0A15.085,15.085,0,0,1,30.638,14.84,15.085,15.085,0,0,1,15.319,29.68,15.085,15.085,0,0,1,0,14.84,15.085,15.085,0,0,1,15.319,0Z" transform="translate(3.83 9.574)" fill="#313a46"/>
      <text id="DESK" transform="translate(11 36)" fill="#da03d8" font-size="33" font-family="SegoeUI, Segoe UI"><tspan x="0" y="0">DESK</tspan></text>
    </svg> -->
 
    

    <!-- <svg xmlns="http://www.w3.org/2000/svg" width="35" height="44" viewBox="0 0 35 44" *ngIf="isCollapsed">
      <path id="Path_5" data-name="Path 5" d="M16.8,0A16.8,16.8,0,1,1,0,16.8,16.8,16.8,0,0,1,16.8,0Z" transform="translate(0 7.616)" fill="#fff"/>
      <path id="Path_6" data-name="Path 6" d="M15.319,0A15.085,15.085,0,0,1,30.638,14.84,15.085,15.085,0,0,1,15.319,29.68,15.085,15.085,0,0,1,0,14.84,15.085,15.085,0,0,1,15.319,0Z" transform="translate(3.83 9.574)" fill="#313a46"/>
      <text id="D" transform="translate(11 36)" fill="#da03d8" font-size="33" font-family="SegoeUI, Segoe UI"><tspan x="0" y="0">D</tspan></text>
    </svg> -->

    <svg xmlns="http://www.w3.org/2000/svg" width="68" height="34" viewBox="0 0 68 34" *ngIf="!isCollapsed">
      <rect id="Rectangle_11" data-name="Rectangle 11" width="31" height="34" fill="#4682A9"/>
      <g id="Group_11" data-name="Group 11" transform="translate(-1425 -347)">
        <line id="Line_10" data-name="Line 10" y2="13.5" transform="translate(1460.731 351.746)" fill="none" stroke="#4682A9" stroke-width="3"/>
        <line id="Line_14" data-name="Line 14" x2="15" transform="translate(1459.731 353.246)" fill="none" stroke="#4682A9" stroke-width="3"/>
        <line id="Line_16" data-name="Line 16" x2="15" transform="translate(1459.731 363.746)" fill="none" stroke="#4682A9" stroke-width="3"/>
        <line id="Line_20" data-name="Line 20" y2="13.5" transform="translate(1473.241 362.246)" fill="none" stroke="#4682A9" stroke-width="3"/>
        <line id="Line_22" data-name="Line 22" x1="15.019" transform="translate(1459.222 374.246)" fill="none" stroke="#4682A9" stroke-width="3"/>
        <path id="Subtraction_1" data-name="Subtraction 1" d="M82.269-29h-4L69-39.976v-3.082l8.961-10.449h3.572L71.023-41.749,82.268-29Z" transform="translate(1408.731 405.253)" fill="#4682A9" stroke="rgba(0,0,0,0)" stroke-miterlimit="10" stroke-width="1"/>
      </g>
      <line id="Line_23" data-name="Line 23" x2="15" transform="translate(6.213 16.5)" fill="none" stroke="#fff" stroke-width="3"/>
      <path id="Subtraction_3" data-name="Subtraction 3" d="M71.707-29H65.213v-5h2.871v2.4h3.657c3.2,0,5.723-.868,7.5-2.58s2.683-4.173,2.683-7.314c0-3.124-.842-5.5-2.5-7.062s-4.189-2.354-7.512-2.354H68.084V-49H65.213v-4.507H71.98c4.3,0,7.567,1,9.716,2.986s3.239,5,3.239,8.959a12.093,12.093,0,0,1-3.6,9.118A13.407,13.407,0,0,1,71.707-29Z" transform="translate(-59 57.753)" fill="#f4f4f5" stroke="rgba(0,0,0,0)" stroke-miterlimit="10" stroke-width="1"/>
      <g id="Rectangle_12" data-name="Rectangle 12" transform="translate(29)" fill="none" stroke="#4682A9" stroke-width="1">
        <rect width="39" height="34" stroke="none"/>
        <rect x="0.5" y="0.5" width="38" height="33" fill="none"/>
      </g>
    </svg>

    
    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="34" viewBox="0 0 31 34" *ngIf="isCollapsed">
      <rect id="Rectangle_13" data-name="Rectangle 13" width="31" height="34" fill="#4682A9"/>
      <line id="Line_24" data-name="Line 24" x2="15" transform="translate(6.213 16.5)" fill="none" stroke="#fff" stroke-width="3"/>
      <path id="Subtraction_4" data-name="Subtraction 4" d="M71.707-29H65.213v-5h2.871v2.4h3.657c3.2,0,5.723-.868,7.5-2.58s2.683-4.173,2.683-7.314c0-3.124-.842-5.5-2.5-7.062s-4.189-2.354-7.512-2.354H68.084V-49H65.213v-4.507H71.98c4.3,0,7.567,1,9.716,2.986s3.239,5,3.239,8.959a12.093,12.093,0,0,1-3.6,9.118A13.407,13.407,0,0,1,71.707-29Z" transform="translate(-59 57.753)" fill="#fff" stroke="rgba(0,0,0,0)" stroke-miterlimit="10" stroke-width="1"/>
    </svg>
    

  
 
  
    
  </a>

  
</div>
<ul nz-menu nzTheme="light" nzMode="inline" [nzInlineCollapsed]="isCollapsed">



  <li nz-menu-item [routerLinkActive]="['ant-menu-item-selected']">
    <a routerLink="/my-feedback" class="sidebar-tooltip-link" [attr.aria-label]="isCollapsed ? 'My Feedbacks' : null">
      <i nz-icon nzType="inbox" class="sidebar-tooltip" [attr.data-tooltip]="isCollapsed ? 'My Feedbacks' : null"></i>
      <span>My Feedbacks</span>
    </a>
  </li>

  <li nz-menu-item [routerLinkActive]="['ant-menu-item-selected']">
    <a routerLink="/feedback" class="sidebar-tooltip-link" [attr.aria-label]="isCollapsed ? 'All Feedbacks' : null">
      <i nz-icon nzType="solution" class="sidebar-tooltip" [attr.data-tooltip]="isCollapsed ? 'All Feedbacks' : null"></i>
      <span>All Feedbacks</span>
    </a>
  </li>

  <li nz-menu-item [routerLinkActive]="['ant-menu-item-selected']" *ngIf="taskPermission">
    <a routerLink="/tasks" class="sidebar-tooltip-link" [attr.aria-label]="isCollapsed ? 'Tasks' : null">
      <i nz-icon nzType="reconciliation" class="sidebar-tooltip" [attr.data-tooltip]="isCollapsed ? 'Tasks' : null"></i>
      <span>Tasks</span>
    </a>
  </li>

  <li nz-menu-item [routerLinkActive]="['ant-menu-item-selected']" *ngIf="taskPermission">
    <a routerLink="/work-dashboard" class="sidebar-tooltip-link" [attr.aria-label]="isCollapsed ? 'Work Dashboard' : null">
      <i nz-icon nzType="check-circle" class="sidebar-tooltip" [attr.data-tooltip]="isCollapsed ? 'Work Dashboard' : null"></i>
      <span>Work Dashboard</span>
    </a>
  </li>

  <li nz-menu-item [routerLinkActive]="['ant-menu-item-selected']" *ngIf="deploymentPermission">
    <a routerLink="/deployments" class="sidebar-tooltip-link" [attr.aria-label]="isCollapsed ? 'Deployments' : null">
      <i nz-icon nzType="cloud-upload" class="sidebar-tooltip" [attr.data-tooltip]="isCollapsed ? 'Deployments' : null"></i>
      <span>Deployments</span>
    </a>
  </li>
  <!-- <li nz-menu-item [routerLinkActive]="['ant-menu-item-selected']" *ngIf="userMyEmailsPermission">
    <a routerLink="/my-emails" >
      <i nz-icon nzType="mail"></i>
      <span>My Emails</span>
    </a>
  </li>

  <li nz-menu-item [routerLinkActive]="['ant-menu-item-selected']" *ngIf="userEmailsPermission">
    <a routerLink="/emails" >
      <i nz-icon nzType="mail"></i>
      <span>Emails</span>
    </a>
  </li>  -->

  <li nz-menu-item [routerLinkActive]="['ant-menu-item-selected']" *ngIf="userDomainsPermission">
    <a routerLink="/domains" class="sidebar-tooltip-link" [attr.aria-label]="isCollapsed ? 'Domains' : null">
      <i nz-icon nzType="node-expand" class="sidebar-tooltip" [attr.data-tooltip]="isCollapsed ? 'Domains' : null"></i>
      <span>Domains</span>
    </a>
  </li>

  <li nz-submenu [nzTitle]="cardsTitle" [routerLinkActive]="['ant-menu-item-selected']" [attr.aria-label]="isCollapsed ? 'Cards' : null">
    <ng-template #cardsTitle>
      <span nz-icon nzType="file-image" class="sidebar-tooltip" [attr.data-tooltip]="isCollapsed ? 'Cards' : null"></span>
      <span *ngIf="!isCollapsed">Cards</span>
    </ng-template>
    <ul>
      <li nz-menu-item [routerLinkActive]="['ant-menu-item-selected']">
        <a routerLink="/greetings">
          <i nz-icon nzType="idcard" nzTheme="outline"></i>
          <span>Recognition Cards</span>
        </a>
      </li>
      <li nz-menu-item [routerLinkActive]="['ant-menu-item-selected']" *ngIf="userBdayCardsPermission">
        <a routerLink="/birthday-cards" >
          <i nz-icon nzType="picture" nzTheme="outline"></i>
          <span>Birthday Cards</span>
        </a>
      </li>
      <li nz-menu-item [routerLinkActive]="['ant-menu-item-selected']" *ngIf="userBdayCardsPermission">
        <a routerLink="/anniversary-cards" >
          <i nz-icon nzType="picture" nzTheme="outline"></i>
          <span>Anniversary Cards</span>
        </a>
      </li>
      
    </ul>
  </li>

   

  

  
  


  <!-- <li nz-menu-item >
    <a routerLink="/" >
      <i nz-icon nzType="question-circle"></i>
      <span>Support</span>
    </a>
  </li> -->


  <!-- <li nz-submenu nzTitle="Inventory" nzIcon="project" >
    <ul>
      <li nz-menu-item>Cloud Inventory</li>
      <li nz-menu-item>Hardware Inventory</li>
      <li nz-menu-item>Subscriptions</li>
    </ul>
  </li> -->


  <!-- <li nz-menu-item >
    <a routerLink="/" >
      <i nz-icon nzType="alert"></i>
      <span>Alert</span>
    </a>
  </li> -->


  <!-- <li nz-menu-item >
    <a routerLink="/" >
      <i nz-icon nzType="heart"></i>
      <span>Health</span>
    </a>
  </li> -->


  <!-- <li nz-menu-item >
    <a routerLink="/settings" >
      <i nz-icon nzType="setting"></i>
      <span>Settings</span>
    </a>
  </li> -->

  <!-- <li nz-menu-item >
    <a href="javascript:void(0)" (click)="signOut()" class="logout">
      <i nz-icon nzType="logout"></i>
      <span>Logout</span>
    </a>
  </li> -->


  <!-- <li>
    <div class="user-profile">
      <a nz-dropdown [nzDropdownMenu]="menu">
        User Name
        <span nz-icon nzType="down"></span>
      </a>
      <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu nzSelectable>
          <li nz-menu-item nzDanger><i nz-icon nzType="logout"></i> <span style="margin-left: 10px;">Logout</span></li>
        </ul>
      </nz-dropdown-menu>

      <nz-avatar-group style="margin-left: 5px;">
        <nz-avatar nzIcon="user" style="background-color:#1890FF;"></nz-avatar>
      </nz-avatar-group>
    </div>
  </li> -->

</ul>
 
<button nz-button nzType="primary" (click)="open()" nzShape="circle" style="position:absolute;bottom:60px; left:33%;" [attr.aria-label]="isCollapsed ? 'Notifications' : null">
  <span nz-icon nzType="notification" nzTheme="outline" class="sidebar-tooltip" [attr.data-tooltip]="isCollapsed ? 'Notifications' : null"></span>
</button>

<app-notification [visible]="visible" (setvisible)="setVisible($event)"> </app-notification>
